(() => {
  const SELECTOR = '[data-tncj-cart-transfer]';
  const HANDOFF_PARAM = 'tncj_checkout';
  const TRUSTED_CHECKOUT_HOSTS = new Set([
    'toyandcomicjunkie.com',
    'www.toyandcomicjunkie.com',
    'toy-and-comic-junkie.myshopify.com',
  ]);

  const trustedCheckoutUrl = (rawUrl) => {
    try {
      const url = new URL(rawUrl);
      const checkoutPath = /\/(?:invoices|checkouts)\//i.test(url.pathname);
      return url.protocol === 'https:' && TRUSTED_CHECKOUT_HOSTS.has(url.hostname.toLowerCase()) && checkoutPath
        ? url
        : null;
    } catch (_error) {
      return null;
    }
  };

  const encodePayload = (payload) => {
    const bytes = new TextEncoder().encode(JSON.stringify(payload));
    let binary = '';
    bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  };

  const getStoreCart = async () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error(`Cart snapshot failed: ${response.status}`);
    const cart = await response.json();
    const items = Array.isArray(cart.items)
      ? cart.items
          .map((item) => ({
            variant_id: String(item.variant_id || item.id || ''),
            quantity: Number(item.quantity || 0),
            title: String(item.product_title || item.title || '').slice(0, 160),
          }))
          .filter((item) => /^\d+$/.test(item.variant_id) && item.quantity > 0)
      : [];
    return items;
  };

  const openFocWithCart = async (control) => {
    if (!control || control.dataset.tncjTransferBusy === '1' || control.disabled) return;
    control.dataset.tncjTransferBusy = '1';
    control.setAttribute('aria-busy', 'true');

    const rawTarget = control.dataset.tncjTarget || control.getAttribute('href') || 'https://foc.toyandcomicjunkie.com/';
    try {
      const items = await getStoreCart();
      const target = new URL(rawTarget, window.location.origin);
      target.searchParams.set('shopify_cart', encodePayload({ version: 1, items }));
      target.searchParams.set('from_store', '1');
      window.location.assign(target.toString());
    } catch (error) {
      console.warn('TNCJ cart transfer unavailable; opening FOC directly.', error);
      window.location.assign(rawTarget);
    }
  };

  const clearStoreCartThenContinue = async () => {
    const pageUrl = new URL(window.location.href);
    const checkoutUrl = trustedCheckoutUrl(pageUrl.searchParams.get(HANDOFF_PARAM));
    if (!checkoutUrl) return;

    const cleanPageUrl = new URL(pageUrl.toString());
    cleanPageUrl.searchParams.delete(HANDOFF_PARAM);
    window.history.replaceState({}, document.title, cleanPageUrl.toString());

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      await fetch(`${root}cart/clear.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: '{}',
      });
    } catch (error) {
      console.warn('TNCJ could not clear the mirrored storefront cart before checkout.', error);
    } finally {
      window.location.replace(checkoutUrl.toString());
    }
  };

  document.addEventListener('click', (event) => {
    const control = event.target.closest(SELECTOR);
    if (!control) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openFocWithCart(control);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearStoreCartThenContinue, { once: true });
  } else {
    clearStoreCartThenContinue();
  }
})();
